/**
 * Serviço para gerenciar os assets e configurações do tema atual
 */

// Obter o tema atual das variáveis de ambiente
export const getCurrentTheme = () => {
  return process.env.REACT_APP_THEME || 'default';
};

// Obter o título da aplicação
export const getAppTitle = () => {
  return process.env.REACT_APP_TITLE || 'UrbeTalk';
};

// Obter o caminho para um asset específico do tema atual
export const getThemeAsset = (assetName) => {
  const theme = getCurrentTheme();
  return `/themes/${theme}/${assetName}`;
};

// Obter o caminho para logos internos (dentro de src/assets)
export const getInternalLogo = (logoName) => {
  const theme = getCurrentTheme();
  try {
    // Usando importação dinâmica para logos dentro de src/assets
    return require(`../assets/themes/${theme}/${logoName}`);
  } catch (error) {
    console.warn(`[TEMA] Não foi possível carregar ${logoName} para o tema ${theme}, usando tema padrão`);
    return require(`../assets/themes/default/${logoName}`);
  }
};

// Obter todas as ilustrações para o tema atual
export const getThemeIllustrations = () => {
  const theme = getCurrentTheme();
  console.log(`[TEMA] Obtendo ilustrações para o tema ${theme}`);
  
  // Pré-definimos os contextos possíveis em tempo de compilação
  // Esta é a única forma de usar require.context com Webpack
  let illustrations = [];
  
  try {
    // Tratamos cada tema separadamente
    if (theme === 'default') {
      const defaultContext = require.context('../assets/themes/default/ilustrations', false, /\.png$/);
      illustrations = defaultContext.keys().map(defaultContext);
    } 
    else if (theme === 'urbe') {
      try {
        const urbeContext = require.context('../assets/themes/urbe/ilustrations', false, /\.png$/);
        illustrations = urbeContext.keys().map(urbeContext);
      } catch (error) {
        console.warn(`[TEMA] Não foi possível carregar ilustrações específicas para o tema urbe, usando tema padrão`);
        const defaultContext = require.context('../assets/themes/default/ilustrations', false, /\.png$/);
        illustrations = defaultContext.keys().map(defaultContext);
      }
    }
    else {
      // Para qualquer outro tema, use o padrão
      console.warn(`[TEMA] Tema ${theme} não tem configuração específica para ilustrações, usando tema padrão`);
      const defaultContext = require.context('../assets/themes/default/ilustrations', false, /\.png$/);
      illustrations = defaultContext.keys().map(defaultContext);
    }
    
    return illustrations;
  } catch (error) {
    console.warn(`[TEMA] Erro ao carregar ilustrações, usando ilustrações padrão`, error);
    // Fallback para o tema padrão
    const defaultContext = require.context('../assets/themes/default/ilustrations', false, /\.png$/);
    return defaultContext.keys().map(defaultContext);
  }
};

export const getWaBackgroundImage = () => {
  const theme = getCurrentTheme();
  console.log(`[TEMA] Obtendo imagem de fundo whatsapp para o tema ${theme}`);   
  try {
    // Usando importação dinâmica para logos dentro de src/assets
    return require(`../assets/themes/${theme}/wa-background.png`);
  } catch (error) {
    console.warn(`[TEMA] Não foi possível carregar background para o tema ${theme}, usando tema padrão`);
    return require(`../assets/themes/default/wa-background.png`);
  }
};

// Aplicar favicon e título dinâmicos no runtime
export const applyDocumentCustomization = () => {
  const theme = getCurrentTheme();
  const title = getAppTitle();
  
  // Atualizar o título da página no runtime (como backup para o método de build)
  document.title = title;
  
  // Atualizar o favicon
  const faviconLink = document.querySelector('link[rel="icon"]');
  if (faviconLink) {
    faviconLink.href = `/themes/${theme}/favicon.ico`;
  }
  
  // Atualizar o shortcut icon
  const shortcutIconLink = document.querySelector('link[rel="shortcut icon"]');
  if (shortcutIconLink) {
    shortcutIconLink.href = `/themes/${theme}/favicon.ico`;
  }
  
  // Atualizar o apple-touch-icon
  const appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
  if (appleTouchIcon) {
    appleTouchIcon.href = `/themes/${theme}/apple-touch-icon.png`;
  }
  
  // Atualizar o manifest.json
  const manifestLink = document.querySelector('link[rel="manifest"]');
  if (manifestLink) {
    manifestLink.href = `/themes/${theme}/manifest.json`;
  }
};